import {Box, Button} from '@mui/material';
import StopCircleIcon from '$assets/svgs/stop-circle.svg?react';
import '../styles.scss';
import {
  eoCheckInTime,
  eoCheckInTimeContainer,
  eoCheckInTimerContainer,
  eoStopTimer,
} from './styles';
import FrontdeskButton from '~/components/FrontdeskButton';

type CheckInTimerComponentProps = {
  currentMinutes: number;
  currentSeconds: number;
  handleEndTimer: () => void;
  showStopTimer: boolean;
  isDoctor?: boolean;
  disabled?: boolean;
};

const CheckInTimerComponent = (props: CheckInTimerComponentProps) => {
  const {
    currentMinutes,
    currentSeconds,
    handleEndTimer,
    showStopTimer,
    isDoctor,
    disabled,
  } = props;

  return (
    <Box sx={eoCheckInTimerContainer}>
      <Box>Time since check in</Box>
      <Box sx={eoCheckInTimeContainer} className="primary">
        <Box sx={eoCheckInTime}>{String(currentMinutes).padStart(2, '0')}</Box>:
        <Box sx={eoCheckInTime}>{String(currentSeconds).padStart(2, '0')}</Box>
      </Box>
      {showStopTimer &&
        (isDoctor ? (
          <FrontdeskButton
            title="End consultation"
            variant="primary"
            disabled={disabled}
            onClick={handleEndTimer}
          />
        ) : (
          <Button
            onClick={handleEndTimer}
            sx={eoStopTimer}
            variant="text"
            color="error"
            disabled={disabled}
          >
            <StopCircleIcon className="stop-timer-icon" /> Stop Timer
          </Button>
        ))}
    </Box>
  );
};

export default CheckInTimerComponent;
